import { createSlice } from "@reduxjs/toolkit";
import {
  getCalendarFeedUrl,
  regenerateCalendarFeedUrl,
} from "../thunks/calendarFeedThunk";

const initialState = {
  calendarFeedUrl: null,
  loading: false,
  error: null,
  urlUpdated: false,
};

const calendarFeedSlice = createSlice({
  name: "calendarFeed",
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
    resetUrlUpdated: (state) => {
      state.urlUpdated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Calendar Feed URL
      .addCase(getCalendarFeedUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCalendarFeedUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.calendarFeedUrl = action.payload.url;
        state.error = null;
      })
      .addCase(getCalendarFeedUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Regenerate Calendar Feed URL
      .addCase(regenerateCalendarFeedUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(regenerateCalendarFeedUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.calendarFeedUrl = action.payload.url;
        state.urlUpdated = true;
        state.error = null;
      })
      .addCase(regenerateCalendarFeedUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError, resetUrlUpdated } = calendarFeedSlice.actions;
export default calendarFeedSlice.reducer;
